import { GenericCrudPage } from '@/components/GenericCrudPage';
import { ordersConfig } from '@/pages/configs';

export default function OrdersPage() {
  return <GenericCrudPage config={ordersConfig} />;
}
